// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"671":"98dfdbf88039d916","675":"55bf8a2d9bd1bb42"}[chunkId] + ".js";
};